export const environment = {
  production: true,
  showTestMessage: false,
  baseUrl: './usilenceApi'
};



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/environments/environment.ts